module.exports = __webpack_public_path__ + "static/media/logo_pgbank.bd1174eb.svg";